import { FormattedMessage } from 'react-intl'
import QuotasStatsBarChart from './QuotasStatsBarChart'
import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { useAccountQuotas } from '../hooks'

function FeaturesQuotaStats() {
  const quotas = useAccountQuotas()

  return (
    <Box>
      <Typography variant="subtitle2" color="textSecondary" mb={2}>
        <FormattedMessage id="account.cards.usage.featuresTitle" />
      </Typography>
      <QuotasStatsBarChart {...quotas.mapsQuota} labelId="maps" />
      <QuotasStatsBarChart {...quotas.mapsPublic} labelId="mapsPublic" />
    </Box>
  )
}

export default FeaturesQuotaStats
